import { Class } from "core/Abacus.Utilities";

let FilteredSearchOptions = {
  items: "li",
  dropdown: "#dropdownMenuOffset"
};

class FilteredSearch extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.setOptions(FilteredSearchOptions, options);
    this.setupEvents();
  }

  setupEvents() {
    var self = this;
    $(this.element)
      .find(".dropdown-toggle")
      .on("click", function() {
        $(self.element).toggleClass("open");
        self.toggleDropdownDisplay();
      });

    $(this.element)
      .find(this.options.items)
      .on("click", function(evt) {
        self.selectedElement(this);
      });

    $(this.element)
      .find(this.options.items)
      .on("keypress", function(event) {
        let keyCode = event.keyCode ? event.keyCode : event.which;
        if (keyCode == 13) {
          self.selectedElement(this);
        }
      });

    $(this.element)
      .find(this.options.items)
      .on("keydown", function(evt) {
        if (evt.which === 40) {
          evt.preventDefault();
          if (
            $(this)
              .next()
              .hasClass("selected")
          ) {
            $(this)
              .next()
              .next()
              .focus();
          } else {
            $(this)
              .next()
              .focus();
          }
        } else if (evt.which === 38) {
          evt.preventDefault();
          if (
            $(this)
              .prev()
              .hasClass("selected")
          ) {
            $(this)
              .prev()
              .prev()
              .focus();
          } else {
            $(this)
              .prev()
              .focus();
          }
        }
      });
  }

  selectedElement(element) {
    var self = this;
    $(this.element)
      .find(this.options.items)
      .removeClass("selected");
    $(element).addClass("selected");
    $(self.element)
      .find("#parametrics")
      .attr("value", element.dataset.filterSearch);
    $(this.element).toggleClass("open");
    $(this.options.dropdown)
      .text($(element).text())
      .focus();
    this.toggleDropdownDisplay();
  }

  toggleDropdownDisplay() {
    const element = $(this.options.dropdown);
    element.attr("aria-expanded") === "true"
      ? element.attr("aria-expanded", "false")
      : element.attr("aria-expanded", "true");
    if ($(this.element).hasClass("open")) {
      $(element)
        .next()
        .attr("aria-hidden", false)
        .end()
        .next()
        .find("li")
        .attr("tabindex", "0");
    } else {
      $(element)
        .next()
        .attr("aria-hidden", true)
        .end()
        .next()
        .find("li")
        .removeAttr("tabindex");
    }
  }
}

export { FilteredSearch };



// WEBPACK FOOTER //
// ./Javascript/core/classes/mast.filter.search.class.js